//引入封装的axios
import { get, post } from './http'
//验证登录账号密码api
export const apiUser = p => post('index.php?c=entry&m=wxl_oms&do=login', p)

//退出账号
export const apiUserOut = p => get('index.php?c=entry&op=login_out&do=login&m=wxl_oms', p)

//key验证发送与验证
export const apiKey = p => post('index.php?c=entry&do=verifycode&op=check_imgcode&m=wxl_oms&pd=creat', p)
export const apiIsKey = p => post('index.php?c=entry&do=verifycode&op=check_imgcode&m=wxl_oms&pd=check', p)

//手机号验证码
export const apiMessage = p => post('index.php?c=entry&do=verifycode&m=wxl_oms', p)

//检测验证码是否正确
export const apiIsMessage = p => post('index.php?c=entry&do=verifycode&op=check_smscode&m=wxl_oms', p)

// 手机号注册账号
export const apiRegister = p => post('index.php?c=entry&do=register&m=wxl_oms', p)

//判断账号是否已注册
export const apiAccountThere = p => post('index.php?c=entry&op=mobile_exist&do=login&m=wxl_oms', p)

//重置密码
export const apiRestPassword = p => post('index.php?c=entry&do=forget&op=reset&m=wxl_oms', p)

//地址库
export const apiSite = p => post('index.php?c=entry&do=qqgjlist&m=wxl_oms', p)

//获取报价
export const apiOffer = p => post('index.php?c=entry&do=bj&op=ajaxcx&m=wxl_oms', p)

//获取左侧列表
export const apiNavData = p => post('index.php?c=entry&do=getmenu&m=wxl_oms', p)

//获取中国地址
export const apiZHCN = p => post('index.php?c=entry&do=qqgjlist&element=1&m=wxl_oms', p)

//获取用户地址库
export const apiAddressBook = p => post('index.php?c=entry&do=pro&m=wxl_oms', p)

//增加用户地址库
export const apiAddDZ = p => post('index.php?c=entry&do=pro&m=wxl_oms', p)

//传递商品详情
export const apiShop = p => post('index.php?c=entry&do=order&m=wxl_oms', p)

//上传图片
export const apiXls = p => post('index.php?c=entry&do=order&m=wxl_oms', p)

//订单列表
export const apiOrderStatus = p => post('index.php?c=entry&do=order&m=wxl_oms', p)

//订单详情
export const apiOrderDetails = p => post('index.php?c=entry&do=order&m=wxl_oms', p)

//获取用户详情
export const apiUserData = p => post('index.php?c=entry&do=mc&m=wxl_oms&op=userinfo', p)

//获取管理订单列表
export const apiManageOrders = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms', p)

//取消订单
export const apiRemoveOrders = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=qx', p)
// ______________________________________________________________________


//订单审核
export const apiAudit = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=queren', p)

//设为问题件操作
export const apiIssue = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=wtjsz', p)

//更改订单状态
export const apiChangeState = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=ztsz', p)

//更改（改签）订单收件地址
export const apiChangeAddess = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=gq', p)

// 添加订单转单号
export const apiAddOdd = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=zynum&pd=ok', p)

//添加订单附加费
export const apiAdditionalCharge = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=otherprice&pd=ok', p)

//订单签收
export const apiSignFor = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=qs&pd=okqs', p)

// //订单某个字段通过表格编辑操作更新内容
// export const apiRemoveOrders = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=gxorderinfo', p)

//转运状态设置
export const apiTransferSet = p => post('index.php?c=entry&do=kd&m=wxl_oms&op=zy&pd=okzy', p)

//派送状态设置
export const apiDelivery = p => post('index.php?c=entry&do=kd&m=wxl_oms&op=ps&pd=okps', p)

//退货状态设置
export const apiSalesReturn = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=tuihe&pd=oktuihe', p)

export const apiSalesReturn_1 = p => post('index.php?c=entry&do=orderadmin&m=wxl_oms&op=tuihe&pd=oktuihe', p)

//拒收状态设置
export const apiRejection = p => post('index.php?c=entry&do=kd&m=wxl_oms&op=noqs&pd=oknoqs', p)

// 已收件设置（上门收件时，司机操作确认已收到件）
export const apiReceive = p => post('index.php?c=entry&do=kd&m=wxl_oms&op=sj', p)
// ______________________________________________________________________

//入库操作
export const apiBePutInStorage = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=ruku&pd=okruku', p)

//单独入库操作
export const apiNewBePutInStorage = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=ruku', p)

// 出库操作
export const apiDeliveryCargoStorage = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=outck&pd=okout', p)

// 单独出库操作
export const apiDeliveryStorage = p => post('index.php?c=entry&do=ck&m=wxl_oms', p)

// ______________________________________________________________________

// 账单api
export const apiBill = p => post('index.php?c=entry&do=fd&m=wxl_oms&op=list&pd=getlist', p)

// 月结用户
export const apiTimeBill = p => post('index.php?c=entry&do=fd&m=wxl_oms&op=soalist&pd=getlist', p)

// ______________________________________________________________________

//现结订单管理
export const apiManageBill = p => post('index.php?c=entry&do=fdadmin&m=wxl_oms&op=list', p)

//月结订单管理
export const apiManageTimeBill = p => post('index.php?c=entry&do=fdadmin&m=wxl_oms&op=soalist&pd=getlist', p)

//添加周期账单
export const apiAddPeriodBill = p => post('index.php?c=entry&do=fdadmin&m=wxl_oms&op=soa&pd=addsoa', p)

//付款审核
export const apiPayAudit = p => post('index.php?c=entry&do=fdadmin&m=wxl_oms&op=payok&pd=okpay', p)

//用户付款
export const apiPayment = p => post('index.php?c=entry&do=pay&m=wxl_oms', p)
// ______________________________________________________________________

//头像上传
export const apiHeaderImage = p => post('index.php?c=entry&do=pro&m=wxl_oms&op=avatar', p)

//旧手机号验证
export const apiUsedMobile = p => post('index.php?c=entry&do=verifycode&op=check_code&m=wxl_oms', p)

//新手机号验证
export const apiNewsMobile = p => post('index.php?c=entry&do=bond&m=wxl_oms&op=mobile', p)

//新邮箱验证
export const apiNewsMaile = p => post('index.php?c=entry&do=bond&m=wxl_oms&op=email', p)

//更改密码
export const apiChangePassword = p => post('index.php?c=entry&do=bond&m=wxl_oms&op=password', p)

//绑定微信
export const apiWeChat = p => post('index.php?c=entry&do=bond&m=wxl_oms&op=wxqr', p)

//对账单信息
export const apiReconciliation = p => post('index.php?c=entry&do=mc&m=wxl_oms&op=dzdsz', p)

//修改名字
export const apiRename = p => post('index.php?c=entry&do=pro&m=wxl_oms&op=editprofile', p)

//修改开票信息
export const apiInvoice = p => post('index.php?c=entry&do=mc&m=wxl_oms&op=fpsz', p)

// 用户信息
export const apiUserInfo = p => post('index.php?c=entry&do=bond&m=wxl_oms&op=settings', p)

//修改提现信息
export const apiWithdrawal = p => post('index.php?c=entry&do=mc&m=wxl_oms&op=cashsz', p)

// ______________________________________________________________________
//发起提现
export const apiStartWithdrawal = p => post('index.php?c=entry&do=fd&m=wxl_oms&op=tixian', p)

//发起开票申请
export const apiMakeInvoice = p => post('index.php?c=entry&do=fd&m=wxl_oms&op=fp', p)
// ______________________________________________________________________
//提现审核列表
export const apiAudit_list = p => post('index.php?c=entry&do=fdadmin&m=wxl_oms&op=admintx', p)

//确定提现审核 
export const apiAudit_withdraw = p => post('index.php?c=entry&do=fdadmin&m=wxl_oms&op=admintx&pd=paytx', p)

export const apiAudit_invoice = p => post('index.php?c=entry&do=fdadmin&m=wxl_oms&op=admintx&pd=fpok', p)

//测试
// export const apiTest = p => post('index.php?c=entry&do=tz&m=wxl_oms&op=gonggao', p)
// ------------------------------------------------------------------------------------------------------------
//获取仓库管理列表
export const apiWarehouse = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=ckadmin', p)

//修改/添加仓库信息
export const apiWarehouseOperation = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=ckadmin', p)

//删除仓库
export const apiRemoveWarehouse = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=ckadmin', p)

//仓位管理
export const apiFreightSpace = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=ckadmin&pd=gsadmin', p)
// ------------------------------------------------------------------------------------------------------------
//获取物品类型
export const aptGoodsInfo = p => post('index.php?c=entry&m=wxl_oms&do=wptype', p)
// ------------------------------------------------------------------------------------------------------------
//获取打包信息
export const aptPackinfo = p => post('index.php?c=entry&do=ck&m=wxl_oms&&op=dabao', p)
//获取待打包列表
export const aptToBePacked = p => post('index.php?c=entry&do=ck&m=wxl_oms&op=list&pd=getlist', p)
// ------------------------------------------------------------------------------------------------------------
//获取营销网址信息
export const apiGetMarketing = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=siteinfo', p)

//提交营销网址基本信息
export const apiSubmitMarketing = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=postsite', p)
//删除网址
export const apiDelectWeb = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=delsite', p)
//添加幻灯片
export const apiGetLanternSlide = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=ad&pd=post', p)
//读取幻灯片
export const apiSetLanternSlide = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=ad', p)
//删除幻灯片
export const apiDelectLanternSlide = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=ad&pd=del', p)
//读取栏目
export const apiGetColumn = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=category', p)
//删除栏目
export const apiRemoveColumn = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=category&pd=del', p)
//添加/编辑栏目
export const apiAddEditColumn = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=category&pd=post', p)
//添加/编辑文章
export const apiArticle = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=article&pd=post', p)
//获取文章
export const apiGetArticle = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=article', p)
//删除文章
export const apiRemoveArticle = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=article&pd=del', p)
//排序
export const apiSort = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=category&pd=displayorder', p)
// ------------------------------------------------------------------------------------------------------------
// 删除附件
export const apiDelete = p => post('index.php?c=entry&do=upfile&m=wxl_oms&op=delete', p)
// 上传附件
export const apiUpload = p => post('index.php?c=entry&do=upfile&m=wxl_oms&op=upload', p)
// 开关网站
export const apiSwitch = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=sitestatus', p)
// ------------------------------------------------------------------------------------------------------------
// 获取支持的支付方式
export const apiGetPlay = p => post('index.php?c=entry&do=getpay&m=wxl_oms', p)
// 获取钱包余额
export const apiWallet = p => post('index.php?c=entry&do=bond&op=credits&m=wxl_oms', p)
// 发起支付
export const apiPlay = p => post('index.php?c=entry&m=wxl_oms&do=cash', p)
// ------------------------------------------------------------------------------------------------------------
// 推广审核
export const apiPromotionAudit = p => post('index.php?c=entry&do=audit&m=wxl_oms&op=alist', p)

// 添加附加费
export const apiAppAdditional = p => post('index.php?c=entry&do=ck&m=wxl_oms', p)

//系统配置参数
export const apiSystemInfo = p => post('index.php?c=entry&do=index&m=wxl_oms&op=sysconfig', p)

// ------------------------------------------------------------------------------------------------------------
//根据集运、商业件获取国家
export const apiTypeSite = p => post('index.php?c=entry&m=wxl_oms&do=index&op=getgjlist', p)

//获取线路列表
export const apiLineList = p => post('index.php?c=entry&m=wxl_oms&do=index&op=getline', p)

//获取FBA地址库列表
export const apiFba = p => post('index.php?c=entry&do=index&m=wxl_oms&op=fba', p)

//集运下单
export const apiConcentrated = p => post('index.php?c=entry&do=order&m=wxl_oms&op=post&pd=app_post', p)

//广告图获取
export const apiAdImage = p => post('index.php?c=entry&m=wxl_oms&do=banner', p)

//物流状态
export const apiLogistics = p => post('index.php?c=entry&op=search&do=search&m=wxl_oms', p)

//获取客服信息
export const apiService = p => post('index.php?c=entry&do=index&m=wxl_oms&op=kf', p)

//获取仓库数据（新）
export const apiUserWarehouse = p => post('index.php?c=entry&do=ck&op=list&pd=getck&m=wxl_oms', p)

//拒绝接收上门取件
export const apiRefuse = p => post('index.php?c=entry&do=kd&m=wxl_oms', p)

//获取账单信息
export const apiBillInfo = p => post('index.php?c=entry&do=fd&m=wxl_oms&op=fdlist', p)

//获取用户列表
export const apiGetUserList = p => post('index.php?c=entry&do=user&m=wxl_oms&op=display', p)

//获取系统配置
export const apiGetSystemConfiguration = p => post('wxl_oms_api.php?getwebapi=1&getapi=1', p)

//获取系统配置
export const apiGetSystemKey = p => post('index.php?c=entry&do=index&m=wxl_oms&op=config', p)

//获取月结账单
export const apiMonthly = p => post('index.php?c=entry&do=fd&m=wxl_oms&op=soalist', p)

//获取月结账单
export const apiSiteInfo = p => post('wxl_oms_api.php?getwebapi=1&getapi=1', p)

// -----------------------[获取通知 ]-----------------------
export const postMessage = p => post('index.php?c=entry&do=tz&m=wxl_oms&op=notice', p)

// -----------------------[通知全部已读]-----------------------
export const allRead = p => post('index.php?c=entry&do=tz&m=wxl_oms&op=readtz', p)

// -----------------------[营销网站-文章添加Tag]-----------------------
export const yxArticleTag = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=article&pd=tag', p)

// -----------------------[营销网站-获取Tag]-----------------------
export const yxGetTag = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=tag', p)

// -----------------------[营销网站-添加Tag]-----------------------
export const yxAddTag = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=tag&pd=post', p)

// -----------------------[营销网站-文章设置]-----------------------
export const articleCommend = p => post('index.php?c=entry&do=mw&m=wxl_oms&op=article&pd=iscommend', p)

